/**
* In this file we handel to show the Notes details popup screen
**/
import { Modal,Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
* Intial state declaration
* @props pass data and handleClose keywords in Object format
* @data pass show,title and message details
**/
function MessageModal(props) {
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	
  return (
  <Modal 
	show={props.data.show} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="md"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
	  {/*Modal Title*/}
        <Modal.Title><h5> {props.data.title?props.data.title:'Message'}</h5></Modal.Title>
      </Modal.Header>
	  {/*Body Conetent*/}
      <Modal.Body>
	  {props.data.description && props.data.description === true ? 
	  (props.data.message ? <p style={{wordWrap:"break-word"}}>{props.data.message}</p>  : <p style={{textAlign:"center"}}>{t('common.noRecord')}</p>) :
	  (props.data.message ? <h4 style={{wordWrap:"break-word"}}>{props.data.message}</h4>  : <h4 style={{textAlign:"center"}}>{t('common.noRecord')}</h4>)
	  }
	 </Modal.Body>
	 {/*Footer*/}
	  <Modal.Footer>
	   <Button variant="secondary" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'}`} onClick={props.handleClose}>
          {t('modal.close')}
        </Button>
	  </Modal.Footer>
	</Modal>
  );
}

export default MessageModal;
